/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Tue Feb 02 2021 11:29:31 GMT+0100 (czas środkowoeuropejski standardowy)
 */

import { request } from '../utils/request';
import { API_URLS } from '../utils/config';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.PURCHASE_ORDER;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface PurOrderLine {
  discount: number;
  grossamount: number;
  netafterdiscount: number;
  objectid: number;
  objectlabel?:string;
  objectreference?:string;
  poldescription: string;
  polid: number;
  polreference: string;
  poltype: string;
  purchaseOrder: PurchaseOrder;
  qty: number;
  status: string;
  statuslabel?:string;
  statusdate: string;
  taxamount: number;
  taxcode: string;
  totalnetafterdiscount: number;
  unitprice: number;
}

export interface PurOrderLineResponse {
  discount: number;
  grossamount: number;
  netafterdiscount: number;
  objectid: number;
  objectlabel: string;
  objectreference: string;
  poid: number;
  poldescription: string;
  polid: number;
  polreference: string;
  poltype: string;
  poltypelabel: string;
  qty: number;
  status: string;
  statusdate: string;
  statuslabel: string;
  taxamount: number;
  taxcode: string;
  totalnetafterdiscount: number;
  unitprice: number;
}

export interface PurchaseOrder {
  created_at: string;
  created_by: number;
  currcode: string;
  deliveryadrcity: string;
  deliveryadrcountry: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  mgid: number;
  podate: string;
  podescription: string;
  poexpecteddeliverydate: string;
  poexternalref: string;
  pogrossamount: number;
  poid: number;
  ponetamount: number;
  popaymentdelay: string;
  popaymentmode: string;
  poreference: string;
  postatus: string;
  postatusdate: string;
  potaxamount: number;
  potype: string;
  purOrderLines: Array<PurOrderLine>;
  tpidsupplier: number;
  updated_at: string;
  updated_by: number;
}

export interface PurchaseOrderListSearchResponse {
  clientname: string;
  clientreference: string;
  ctreference: string;
  ctrid: number;
  podate: string;
  podescription: string;
  poexpecteddeliverydate: string;
  poexternalref: string;
  pogrossamount: number;
  poid: number;
  ponetamount: number;
  poreference: string;
  postatus: string;
  postatuslabel: string;
  potaxamount: number;
  potype: string;
  potypelabel: string;
  propreference: string;
  refsupplier: string;
  suppliername: string;
  tpidclient: number;
  tpidsupplier: number;
  assetid:number;
  assetlabel:string;
  currcode:string;
}

export interface PurchaseOrderRequest {
  created_at: string;
  created_by: number;
  currcode: string;
  deliveryadrcity: string;
  deliveryadrcountry: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  mgid: number;
  podate: string;
  podescription: string;
  poexpecteddeliverydate: string;
  poexternalref: string;
  pogrossamount: number;
  poid: number;
  ponetamount: number;
  popaymentdelay: string;
  popaymentmode: string;
  poreference: string;
  postatus: string;
  postatusdate: string;
  potaxamount: number;
  potype: string;
  purOrderLines: Array<PurOrderLine>;
  tpidsupplier: number;
  updated_at: string;
  updated_by: number;
}

export interface PurchaseOrderResponse {
  created_at: string;
  created_by: number;
  currcode: string;
  deliveryadrcity: string;
  deliveryadrcitylabel:string;
  deliveryadrcountry: string;
  deliveryadrcountrylabel:string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  mgid: number;
  podate: string;
  podescription: string;
  poexpecteddeliverydate: string;
  poexternalref: string;
  pogrossamount: number;
  poid: number;
  ponetamount: number;
  popaymentdelay: string;
  popaymentdelaylabel: string;
  popaymentmode: string;
  popaymentmodelabel: string;
  poreference: string;
  postatus: string;
  postatusdate: string;
  postatuslabel: string;
  statuslabel?:string;
  potaxamount: number;
  potype: string;
  purOrderLines: Array<PurOrderLineResponse>;
  suppliername: string;
  supplierreference: string;
  tpidsupplier: number;
  updated_at: string;
  updated_by: number;
}

export interface GetPurchaseOrderListByProposalIDParams {
  ctrid: number;
  postatus: string;
}

/**
 * @tags Purchase Order Controller
 * @summary getPurchaseOrderListByProposalID
 */
export function getPurchaseOrderListByProposalID(
  params: GetPurchaseOrderListByProposalIDParams
) {
  return request.get<AbstractResponse<object, PurchaseOrderListSearchResponse>>(
    `${URL}/api/proposal/${params.ctrid}/purchaseOrder`+prepareQueryParams({postatus:params.postatus})
  );
}

export interface UpdateProposalPurchaseOrderStatusParams {
  ctrid: number;
  postatus: string;
}

/**
 * @tags Purchase Order Controller
 * @summary updateProposalPurchaseOrderStatus
 */
export function updateProposalPurchaseOrderStatus(
  params: UpdateProposalPurchaseOrderStatusParams
) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/proposal/${params.ctrid}/updatePOStatus/${params.postatus}`
  );
}

export interface FindPurchaseOrderListByAnyRefParams {
  clientname?: string;
  clientreference?: string;
  ctreference?: string;
  poreference?: string;
  postatus?: string;
  propreference?: string;
  refsupplier?: string;
  suppliername?: string;
  assetid?:number;
}

/**
 * @tags Purchase Order Controller
 * @summary findPurchaseOrderListByAnyRef
 */
export function findPurchaseOrderListByAnyRef(
  params: FindPurchaseOrderListByAnyRefParams
) {
  return request.get<AbstractResponse<object, PurchaseOrderListSearchResponse>>(
    `${URL}/api/purchaseOrder` +
      prepareQueryParams({
        clientname: params.clientname,
        clientreference: params.clientreference,
        ctreference: params.ctreference,
        poreference: params.poreference,
        postatus: params.postatus,
        propreference: params.propreference,
        refsupplier: params.refsupplier,
        suppliername: params.suppliername,
        assetid:params.assetid,
      } as any)
  );
}

export interface CreatePurchaseOrderParams {
  poRequest: PurchaseOrderRequest;
}

/**
 * @tags Purchase Order Controller
 * @summary createPurchaseOrder
 */
export function createPurchaseOrder(params: CreatePurchaseOrderParams) {
  return request.post<AbstractResponse<PurchaseOrderResponse, object>>(
    `${URL}/api/purchaseOrder`,
    params.poRequest
  );
}

export interface GetPurchaseOrderByIDParams {
  poid: number;
}

/**
 * @tags Purchase Order Controller
 * @summary getPurchaseOrderByID
 */
export function getPurchaseOrderByID(params: GetPurchaseOrderByIDParams) {
  return request.get<AbstractResponse<PurchaseOrderResponse, object>>(
    `${URL}/api/purchaseOrder/${params.poid}`
  );
}

export interface UpdatePurchaseOrderParams {
  poRequest: PurchaseOrderRequest;
  poid: number;
}

/**
 * @tags Purchase Order Controller
 * @summary updatePurchaseOrder
 */
export function updatePurchaseOrder(params: UpdatePurchaseOrderParams) {
  return request.put<AbstractResponse<PurchaseOrderResponse, object>>(
    `${URL}/api/purchaseOrder/${params.poid}`,
    params.poRequest
  );
}

export interface UpdatePurchaseOrderStatusParams {
  poid: number;
  postatus: string;
}

/**
 * @tags Purchase Order Controller
 * @summary updatePurchaseOrderStatus
 */
export function updatePurchaseOrderStatus(
  params: UpdatePurchaseOrderStatusParams
) {
  return request.put<AbstractResponse<PurchaseOrderResponse, object>>(
    `${URL}/api/purchaseOrder/${params.poid}/updateStatus/${params.postatus}`
  );
}

/**
 * @tags Purchase Order Controller
 * @summary version
 */
export function version() {
  return request.get<string>(`${URL}/api/version`);
}
